import { ErrorRetry } from "../../common/ErrorRetry";
import { ProductCard } from "./ProductCard";

export function ReportSummaryCategorySection({ state, categoryData }) {
  return state.loading ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">
        Revenue by Product Category
      </span>
      <div className="flex items-center justify-center py-10">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin" />
      </div>
    </div>
  ) : state.error ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">
        Revenue by Product Category
      </span>
      <ErrorRetry message={state.message} onRetry={state.onRetry} />
    </div>
  ) : categoryData.length > 0 ? (
    <div>
      <span className="mb-4 text-xl text-[#1A1A1A]">
        Revenue by Product Category
      </span>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {categoryData.map((product, index) => (
          <ProductCard key={index} {...product} />
        ))}
      </div>
    </div>
  ) : (
    <div className="py-6 text-gray-500 text-center">
      No revenue data available
    </div>
  );
}
